import { memo } from 'react';

import { Routes, Route, Navigate } from 'react-router';

import Layout from '@/components/templates/Layout';
import PermissionsWrapper from '@/components/templates/PermissionsWrapper';

import { CollectionsPage } from './pages/CollectionsPage';
import { ContentPage } from './pages/ContentPage';
import { DatasourcesDocumentsPage } from './pages/DatasourcesDocumentsPage';

export const CollectionsRouter = memo(() => {
  return (
    <Layout>
      <PermissionsWrapper module="collections">
        <Routes>
          <Route path="/" element={<CollectionsPage />} />
          <Route path="/:collectionId" element={<Navigate to="category/faq" replace />} />
          <Route path="/:collectionId/category/:category" element={<DatasourcesDocumentsPage />} />
          <Route path="/:collectionId/category/:category/:datasourceId" element={<ContentPage />} />
        </Routes>
      </PermissionsWrapper>
    </Layout>
  );
});

CollectionsRouter.displayName = 'CollectionsRouter';
